import React from 'react';
import { TableContainer, Box, Paper, Table, TableCell, TableHead, TableRow, TableBody, Button, Tooltip } from "@material-ui/core";
import { withStyles } from "@material-ui/core/styles";
import useStyles from '../../../themes/makeStyles';

const StyledTableCell = withStyles((theme) => ({
    head: {
        backgroundColor: theme.palette.common.white,
        color: theme.palette.primary.main,
    },
    body: {
        fontSize: 10,
    },
}))(TableCell);

export default function InventoryStatus(props) {
    const warehouseData =
        JSON.parse(sessionStorage.getItem("warehouseData")) || {};

    const classes = useStyles();

    const openCloseCompletedInventory = (data) => {
        props.openCloseGrnStatusDetailTable(data)
    }

    function openCloseCompOkDamageInventory(data) {
        props.openCloseCompletedOrPendingInventory(data)
    }

    return (
        <TableContainer component={Paper} className={classes.container}>
            <Table className={classes.table} aria-label="simple table" stickyHeader>
                <TableHead>
                    <TableRow>
                        <StyledTableCell colSpan={6} align="center">
                            <b>Current Inventory Table </b>
                        </StyledTableCell>
                    </TableRow>
                </TableHead>
                <TableHead>
                    <TableRow>
                        <StyledTableCell>
                            <b>SAP GRN Status</b>
                        </StyledTableCell>
                        <StyledTableCell>
                            <Tooltip title={!props.GrnStatusDetailIventoryTable ? "Click to display Current Invetory detail table" : "Close"}>
                                <Button onClick={() => openCloseCompletedInventory("completedPendingInventory")} color='primary' variant='outlined'> <h3>{!props.GrnStatusDetailIventoryTable ? <b> +</b> : <b>-</b>}</h3> </Button>
                            </Tooltip>
                        </StyledTableCell>
                        <StyledTableCell>
                            <b>No. of items</b>
                        </StyledTableCell>
                        <StyledTableCell>
                            <b>Value (Cr.)</b>
                        </StyledTableCell>
                        <StyledTableCell>
                            <b>{warehouseData.warehouse_name.includes('Pravesh') ? "Qty (NOs)" : "Qty (MT)"}</b>
                        </StyledTableCell>
                        <StyledTableCell>
                            <b>Space Occupied (Sq Ft.)</b>
                        </StyledTableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    <TableRow>
                        <TableCell component="th" scope="row">
                            <div>
                                <b>{(props.inventoryDetailData[0] && props.inventoryDetailData[0].sap_type) ? props.inventoryDetailData[0].sap_type : "COMPLETED"}</b>
                            </div>
                        </TableCell>
                        <TableCell>
                            <Tooltip title={!props.CurrInventCompletedOkDamage ? "Show Okay/Damaged in Completed status in Current Invetory" : "Close"}>
                                <Button onClick={() => openCloseCompOkDamageInventory("COMPLETED")} color='primary' variant='outlined'> <h3>{!props.CurrInventCompletedOkDamage ? <b> +</b> : <b>-</b>}</h3> </Button>
                            </Tooltip>
                        </TableCell>
                        <TableCell component="th" scope="row">
                            <div>
                                <b> {(props.inventoryDetailData[0] && props.inventoryDetailData[0].no_of_items) ? props.inventoryDetailData[0].no_of_items : 0} </b>
                            </div>
                        </TableCell>
                        <TableCell component="th" scope="row">
                            <div>
                                <b>{(props.inventoryDetailData[0] && props.inventoryDetailData[0].value_in_cr) ? props.inventoryDetailData[0].value_in_cr : 0}</b>
                            </div>
                        </TableCell>
                        {warehouseData.warehouse_name.includes('Pravesh') ? <TableCell component="th" scope="row">
                            <div>
                                <b>{(props.inventoryDetailData[0] && props.inventoryDetailData[0].unloading_quantity) ? props.inventoryDetailData[0].unloading_quantity : 0}</b>
                            </div>
                        </TableCell> :
                            <TableCell component="th" scope="row">
                                <div>
                                    <b>{(props.inventoryDetailData[0] && props.inventoryDetailData[0].gross_weight) ? props.inventoryDetailData[0].gross_weight : 0}</b>
                                </div>
                            </TableCell>}
                        <TableCell component="th" scope="row">
                            <div>
                                <b>{(props.inventoryDetailData[0] && props.inventoryDetailData[0].bin_space_allocated) ? props.inventoryDetailData[0].bin_space_allocated : 0}</b>
                            </div>
                        </TableCell>
                    </TableRow>
                    <TableRow>
                        <TableCell component="th" scope="row">
                            <div>
                                <b>{(props.inventoryDetailData[1] && props.inventoryDetailData[1].sap_type) ? props.inventoryDetailData[1].sap_type : "PENDING"}</b>
                            </div>
                        </TableCell>
                        <TableCell>
                            <Tooltip title={!props.CurrInventPendingOkDamage ? "Show Okay/Damaged in Pending in Current Invetory" : "Close"}>
                                <Button onClick={() => openCloseCompOkDamageInventory("PENDING")} color='primary' variant='outlined'> <h3>{!props.CurrInventPendingOkDamage ? <b> +</b> : <b>-</b>}</h3> </Button>
                            </Tooltip>
                        </TableCell>
                        <TableCell component="th" scope="row">
                            <div>
                                <b>{(props.inventoryDetailData[1] && props.inventoryDetailData[1].no_of_items) ? props.inventoryDetailData[1].no_of_items : 0}</b>
                            </div>
                        </TableCell>
                        <TableCell component="th" scope="row">
                            <div>
                                <b>{(props.inventoryDetailData[1] && props.inventoryDetailData[1].value_in_cr) ? props.inventoryDetailData[1].value_in_cr : 0}</b>
                            </div>
                        </TableCell>
                        {warehouseData.warehouse_name.includes('Pravesh') ? <TableCell component="th" scope="row">
                            <div>
                                <b>{(props.inventoryDetailData[1] && props.inventoryDetailData[1].unloading_quantity) ? props.inventoryDetailData[1].unloading_quantity : 0}</b>
                            </div>
                        </TableCell> :
                            <TableCell component="th" scope="row">
                                <div>
                                    <b>{(props.inventoryDetailData[1] && props.inventoryDetailData[1].gross_weight) ? props.inventoryDetailData[1].gross_weight : 0}</b>
                                </div>
                            </TableCell>}
                        <TableCell component="th" scope="row">
                            <div>
                                <b>{(props.inventoryDetailData[1] && props.inventoryDetailData[1].bin_space_allocated) ? props.inventoryDetailData[1].bin_space_allocated : 0}</b>
                            </div>
                        </TableCell>
                    </TableRow>
                </TableBody>
            </Table>
        </TableContainer>
    );
} 